/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_Tab_ContactsInputs */

const en_case_detail_tab_contacts = /** @type {(inputs: Case_Detail_Tab_ContactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacts`)
};

const pt_br2_case_detail_tab_contacts = /** @type {(inputs: Case_Detail_Tab_ContactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatos`)
};

/**
* | output |
* | --- |
* | "Contacts" |
*
* @param {Case_Detail_Tab_ContactsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_tab_contacts = /** @type {((inputs?: Case_Detail_Tab_ContactsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_Tab_ContactsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_tab_contacts(inputs)
	return pt_br2_case_detail_tab_contacts(inputs)
});